/* eslint-disable @typescript-eslint/no-namespace -- this is fine */
import { CardString } from './card-types';
import { BettingStructure } from './game-types';
import { type Table } from './generated/prisma/browser';
import { PokerCategory } from './generated/prisma/enums';
import { SortOrder } from './generated/prisma/internal/prismaNamespace';
import { PokerVariant } from './poker-variant';
import { PrismaService } from './prisma.service';
import { ButtonConfiguration, HotkeysBindings } from './settings-types';

export type PrismaTransactionClient = Parameters<Parameters<PrismaService['$transaction']>[0]>[0];

export {};
declare global {
  namespace PrismaJson {
    // eslint-disable-next-line @typescript-eslint/no-empty-object-type -- this is fine
    export type EmptyJson = {};
    export type CardMappings = {
      [key: number]: CardString;
    };

    export type TxCallData = {
      to: string;
      data: string;
      value?: bigint;
    };

    export type PayoutStructure = {
      playersColumns: { playersFrom: number; playersTo: number; percentages: number[] }[];
      rankRows: { rankFrom: number; rankTo: number }[];
    };

    export type LeaderboardPrizeTierStructure = {
      [key: number]: number[];
    };

    export type ContractHistory = {
      [key: string]: number;
    };

    export type SoundVolumes = {
      Player?: number;
      Observer?: number;
      Actions?: number;
      Alerts?: number;
      Chips?: number;
      Deal?: number;
    };

    export type Hotkeys = {
      betOrRaise: HotkeysBindings;
      bringIn: HotkeysBindings;
      call: HotkeysBindings;
      check: HotkeysBindings;
      complete: HotkeysBindings;
      confirm: HotkeysBindings;
      fold: HotkeysBindings;
    };

    export type ButtonConfigurations = {
      onBetButtons: ButtonConfiguration[];
      onPreFlopButtons: ButtonConfiguration[];
      postFlopButtons: ButtonConfiguration[];
    };

    export type GamesFilter = {
      category: PokerCategory;
      games: PokerVariant[];
      label: string;
    };

    export type StakeOption = {
      bettingStructure: BettingStructure;
      min: number;
      max: number | undefined;
      minInclusive?: boolean;
      maxInclusive?: boolean;
    };

    export type TableSortOption = {
      sortOrder: SortOrder;
      orderBy: keyof Table | 'seats' | 'waitlist';
    };
  }
}

export * from './generated/prisma/browser';
export * from './generated/prisma/models';
export * from './generated/prisma/enums';
export * from './betting-structure.utils';
export * from './card-types';
export * from './game-registry';
export * from './poker-variant';
export * from './game-types';
export * from './settings-types';
